import { Checkbox, Stack, Text } from "@biblioteksentralen/react";
import { Filteredtems } from "./getFilteredItems";
import { Filter, FilterableItem } from "./useFilter";

type Props<T extends FilterableItem> = {
  filter: Filter<T>;
  filteredItems: Filteredtems<T>;
};

const FilterOptions = <T extends FilterableItem>({ filter, filteredItems }: Props<T>) => (
  <Stack direction="column">
    {filter.getRelevantOptions(filteredItems.byOtherFilters).map((option, index) => (
      <Checkbox key={index} onChange={() => filter.onClickOption(option)} isChecked={filter.optionIsSelected(option)}>
        <Text fontSize=".9rem">{option.value}</Text>
      </Checkbox>
    ))}
  </Stack>
);

export default FilterOptions;
